import { observable, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';

class ContentSection extends DomainObject {
  id;
  positionId = 1;
  richText = '';
  lexicalState;

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      positionId: observable,
      richText: observable,
      lexicalState: observable
    });

    this.merge(other);
  }
}

export default ContentSection;
